import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoCrew = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 40,
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M25.9545 32.0455V29.3182C25.9545 27.8716 25.3799 26.4842 24.3569 25.4612C23.334 24.4383 21.9466 23.8636 20.5 23.8636H10.9545C9.50791 23.8636 8.12052 24.4383 7.0976 25.4612C6.07467 26.4842 5.5 27.8716 5.5 29.3182V32.0455",
			stroke: "#7F8083",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.6816 14.3182L35.4998 21.1364",
			stroke: "#7F8083",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.4998 14.3182L28.6816 21.1364",
			stroke: "#7F8083",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.728 18.4091C18.7404 18.4091 21.1825 15.967 21.1825 12.9545C21.1825 9.94208 18.7404 7.5 15.728 7.5C12.7155 7.5 10.2734 9.94208 10.2734 12.9545C10.2734 15.967 12.7155 18.4091 15.728 18.4091Z",
			stroke: "#7F8083",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNoCrew;
